import { useState } from 'react';
import { Upload } from 'lucide-react';
import { ImportFilesDialog } from '@/components/finance/bank-ingestion';
import { SourcesImportHistory } from './SourcesImportHistory';

/**
 * ADR-015 D11 — the reframed finance import front door. The fake "Connected"
 * cards (Chase/Plaid, ActBlue/Stripe via API, Venmo CSV) were static mock
 * teasers for integrations that didn't exist, so they were deleted — replaced
 * by the REAL import-history surface (`SourcesImportHistory`) and a clean empty
 * state. The entry is reframed from "Import a bank statement" to "upload any
 * file": one door that accepts bank statements, processor exports, or
 * hand-compiled donation/expense sheets, one or many at a time, and routes each
 * to the right tier (ADR-015 §4).
 *
 * Real bank auto-sync now DOES exist (ADR-070 Plaid bank-pull), but it is set up
 * via the guided "Link a bank" flow on the Banks & processors page — not
 * re-teased with a static card here — and its synced transactions land in the
 * triage inbox. File upload stays the always-available fallback, unchanged.
 */
export function SourcesPage() {
  const [importOpen, setImportOpen] = useState(false);

  return (
    <div className="px-1 pb-16">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-foreground">
            Sources
          </h1>
          <p className="mt-1.5 max-w-xl text-sm text-muted-foreground">
            Upload any file — bank statements, processor exports, or your own
            donation or expense sheets.
          </p>
        </div>
        <button
          type="button"
          onClick={() => setImportOpen(true)}
          className="inline-flex min-h-11 items-center gap-1.5 rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Upload className="h-4 w-4" aria-hidden />
          Upload files
        </button>
      </div>

      <SourcesImportHistory onUpload={() => setImportOpen(true)} />

      <ImportFilesDialog open={importOpen} onOpenChange={setImportOpen} />
    </div>
  );
}
